var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"app"}},[(_vm.first)?_c('first',{on:{"closeFirst":_vm.closeFirst}}):_vm._e(),(!_vm.first)?_c('recognize'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }